import API from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { IResponse, IPKDetail, ITeam } from '@umu/umu-types';

export const savePKInfo = async (data: IPKDetail): Promise<IResponse<{ id: string }>> => {
    return await fetchData(API.SAVE_COURSE_PK_INFO, JSON.stringify(data));
};

export const savePKTeams = async (data: {
    activity_id: string;
    course_id: string;
    teams: ITeam[];
}): Promise<IResponse<{ id: string }>> => {
    data.teams.forEach((team) => {
        delete team.all_users;
        delete team.user_count;
    });
    return await fetchData(API.SAVE_COURSE_PK_TEAMS, JSON.stringify(data));
};
